import { UnderMaintenance } from '@/components/ui';

export const ReportSalePayment = () => {
    return <UnderMaintenance />;
};

ReportSalePayment.displayName = 'ReportSalePayment';
